import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const FieldLabel = ({ label, tooltip }) => (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        {label}
        {tooltip && (
            <Tooltip
                title={
                    <Box
                        component="span"
                        sx={{
                            display: 'block',
                            whiteSpace: 'pre-line',
                            textAlign: 'left',
                            width: '100%',
                        }}
                    >
                        {tooltip}
                    </Box>
                }
                arrow
                placement="top"
                componentsProps={{
                    tooltip: {
                        sx: {
                            textAlign: 'left !important',
                            maxWidth: '340px !important',
                        },
                    },
                }}
            >
                <InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', verticalAlign: 'middle' }} />
            </Tooltip>
        )}
    </Box>
);

export default FieldLabel;
